function removeCurrentYearIfInvalid(el) {
  const [monthEl, yearEl] = el.querySelectorAll("select")

  const monthValue = parseInt(monthEl.value || 0)
  const currentMonth = new Date().getMonth() + 1
  const currentYear = new Date().getFullYear()
  const invalid = monthValue && monthValue < currentMonth
  const currentYearNativeOptionEl = yearEl.querySelector(
    `option[value="${currentYear}"]`,
  )
  const yearCustomSelectEl = el.querySelectorAll(".select")[1]
  const currentYearOptionEl = yearCustomSelectEl?.querySelector(
    `li span[data-value="${currentYear}"]`,
  )
  const currentYearCanonicalOptionEl = el.querySelector(
    `[data-select-option][data-value="${currentYear}"]`,
  )

  if (currentYearNativeOptionEl) currentYearNativeOptionEl.disabled = invalid

  if (currentYearOptionEl) {
    currentYearOptionEl.classList.toggle("hidden", invalid)
  }

  if (currentYearCanonicalOptionEl) {
    currentYearCanonicalOptionEl.dataset.disabled = String(Boolean(invalid))
    currentYearCanonicalOptionEl.setAttribute(
      "aria-disabled",
      String(Boolean(invalid)),
    )
  }
}

const YearMonthInput = {
  mounted() {
    const el = this.el.querySelector("input")
    const [monthEl, yearEl] = this.el.querySelectorAll("select")

    const onChange = () => {
      const yearValue = parseInt(yearEl.value || 0)
      const monthValue = parseInt(monthEl.value || 0)

      // To handle the input not being used in live views
      removeCurrentYearIfInvalid(this.el)

      const value = yearValue * 100 + monthValue
      el.value = value || "" // empty if 0
    }

    // Gotta use the custom event
    yearEl.addEventListener("input", onChange)

    monthEl.addEventListener("input", onChange)
  },

  updated() {
    // To handle the input being used in live views
    removeCurrentYearIfInvalid(this.el)
  },
}
export { YearMonthInput }
